import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The selected parcel(s)/area is outside the MSA levy area. Levy liability estimates are calculated for land within the
  MSA levy area only.
    </p>
    <p>
  You can review areas covered by the MSA levy area by turning on the <strong>MSA Levy Area Boundary</strong> layer on
  the map.
    </p>
    <p>
  Please contact{' '}
  <InlineLink href="mailto:msa.habitatcompensation@delwp.vic.gov.au" text="msa.habitatcompensation@delwp.vic.gov.au" mdxType="InlineLink" />{' '}
  for further information.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      